/**
 * A note's text with its web addresses as links (design 45 §15.4), each opening in a new tab. The
 * split is `linkify`'s; this draws it as React text nodes and anchors, never HTML. Wherever a
 * Jobber note's message is drawn — except inside something that is itself a link, where an anchor
 * may not sit.
 */

import { linkify } from '../lib/linkify.js';

export function LinkedText({ text }: { readonly text: string }) {
  return (
    <>
      {linkify(text).map((part, i) =>
        part.kind === 'link' ? (
          <a key={i} className="note__link" href={part.href} target="_blank" rel="noopener noreferrer">
            {part.text}
          </a>
        ) : (
          part.text
        ),
      )}
    </>
  );
}
